import { TestStatus } from "@app/provider/testData/types";
import { TestDetailsRecord } from "@app/provider/types";

export const isFirstResultView = (testDetails?: TestDetailsRecord): boolean =>
  testDetails?.viewStatus !== TestStatus.VIEWED;
